import { Send } from "lucide-react";
import { useState } from "react";
import { btn } from "../../../../../../components/Button/buttonStyles";

const MessagesCard = ({ onSend }) => {
  const [message, setMessage] = useState("");

  const handleSend = () => {
    if (!message.trim()) return;
    onSend?.(message);
    setMessage("");
  };

  return (
    <section>
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl font-bold text-gray-900">Messages</h2>
      </div>

      <div className="bg-white border border-gray-100 shadow-sm rounded-lg p-5 space-y-3">
        <textarea
          rows={4}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Write a message..."
          className="w-full border border-gray-200 rounded-md p-3 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-brand-500"
        />

        <div className="flex justify-end">
          <button
            onClick={handleSend}
            disabled={!message.trim()}
            className={btn("primary", "sm")}
          >
            <Send className="w-4 h-4" />
            Send
          </button>
        </div>
      </div>
    </section>
  );
};

export default MessagesCard;
